<template>
  <b-card no-body>
    <b-card-body>
      <b-form @submit.prevent="handleFileInputChange">
        <b-button variant="secondary" @click="triggerFileInput">
          <b-icon icon="paperclip"></b-icon>
        </b-button>
        <input ref="fileInput" type="file" accept="image/*" @change="handleFileInputChange" class="d-none" multiple>
      </b-form>
      <b-table responsive class="mt-2" small :items="files" :fields="tableFields" :hover="true" show-empty
        :busy="this.busy">
        <template v-slot:cell(arquivo)="{ item }">
          <span>{{ item.name }}</span>
        </template>
        <template v-slot:cell(action)="{ item }">
          <b-button variant="danger" @click="removeFile(item)" class="ml-2" style="height: 30px"  pill size="sm"  >
              <b-icon icon="trash"></b-icon>
          </b-button>          

        </template>

        <template #empty>
          <p>Nenhum registro encontrado</p>
        </template>

        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

      </b-table>
    </b-card-body>
    <b-card-footer>
      <div class="d-flex justify-content-center mt-3">
        <b-button id="salvarMarca" @click="salvarArquivos" variant="success" style="height: 30px" pill size="sm">
          <div class="btn-size-alinhamento">
            <b-icon icon="check-circle" />
          </div>
          <b-tooltip target="salvarMarca" title="Salvar" triggers="hover"></b-tooltip>
        </b-button>
        <b-button id="cancelarMarca" class="ml-2" @click="cancelar" style="height: 30px" pill size="sm"
          variant="danger">
          <div class="btn-size-alinhamento">
            <b-icon icon="x-circle" />
          </div>
          <b-tooltip target="cancelarMarca" title="Cancelar" triggers="hover"></b-tooltip>
        </b-button>
      </div>
    </b-card-footer>
  </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"

export default {
  props: {
    id: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      busy: false,
      form: {
        file: null,
      },
      files: [],
      tableFields: [
        { key: 'arquivo', label: 'Arquivo' },
        { key: 'action', label: ' ', class: 'text-right' }
      ]
    }
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    handleFileInputChange(event) {
      const selectedFiles = Array.from(event.target.files)
      selectedFiles.forEach(file => {
        this.files.push({ id: null, name: file.name, file: file })
      })
    },
    async removeFile(item) {
      try {
        if (item.id) {
          this.busy = true;
          await new ResourceService(`/api/produtocatalogo/arquivo/${this.id}`).remove(`${item.id}`)
          this.busy = false;
        }
        this.files = this.files.filter(file => file !== item)
        this.$notify({ type: 'success', message: 'Arquivo removido com sucesso!' })
      } catch (error) {
        this.$notify({ type: 'danger', message: 'Erro ao remover o arquivo!' })
      }
    },
    cancelar() {
      this.$emit('fecharModal')
    },
    async salvarArquivos() {
      if (this.files.length === 0) {
        this.$notify({ type: 'warning', message: 'Nenhum arquivo selecionado!' })
        return
      }

      const formData = new FormData()
      this.files.forEach(file => {
        if (!file.id) {
          formData.append('file', file.file)
        }
      })

      try {
        this.busy = true;
        await new ResourceService(`/api/produtocatalogo`).put(`${this.id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        this.busy = false;
        this.$notify({ type: 'success', message: 'Arquivos enviados com sucesso!' })
        this.cancelar()
      } catch (error) {
        this.$notify({ type: 'danger', message: 'Erro ao enviar os arquivos!' })
      }
    },
    async fetchArquivos() {
      try {
        this.busy = true;
        const response = await new ResourceService(`/api/produtocatalogo`).get(`${this.id}/arquivos`)
        this.busy = false;

        if (response.data)
          this.files = response.data.map(file => ({ id: file.id, name: file.nome }))
      } catch (error) {
        this.$notify({ type: 'danger', message: error && error.message ? error.message : 'Erro ao buscar os arquivos!' })
      }
    }
  },
  mounted() {
    this.fetchArquivos()
  }
}
</script>

<style scoped>
.text-right {
  text-align: right;
}
</style>